import { render } from "./CotizacionForm.vue?vue&type=template&id=60653391&scoped=true"
import script from "./CotizacionForm.vue?vue&type=script&lang=js"
export * from "./CotizacionForm.vue?vue&type=script&lang=js"

import "./CotizacionForm.vue?vue&type=style&index=0&id=60653391&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60653391"]])

export default __exports__